import { render } from "./Fav.vue?vue&type=template&id=0eaa534e"
import script from "./Fav.vue?vue&type=script&lang=js"
export * from "./Fav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__